// utils/roleRoutes.js
export const roleToRoute = {
    SUPERADMIN: "/superadmin",
    OWNER: "/management",
    OWNERGROUP: "/management",
    FLEET_MANAGER: "/management",
    VESSEL_MANANGER: "/management",
  };
  